export function cartesianProduct<T>(
  sets: readonly (readonly T[])[],
): readonly (readonly T[])[] {
  return sets.reduce<readonly (readonly T[])[]>(
    (tuples, set) =>
      tuples.flatMap((tuple) => set.map((value) => [...tuple, value])),
    [[]],
  );
}
